import { render, staticRenderFns } from "./gb-whatsapp-pc-windows.vue?vue&type=template&id=0c2b47de&scoped=true"
import script from "./gb-whatsapp-pc-windows.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-pc-windows.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-pc-windows.vue?vue&type=style&index=0&id=0c2b47de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b47de",
  null
  
)

export default component.exports